import React, { useEffect,useState } from "react";
import { useSetting } from "store/settings";
import { useCore } from "store/core";
import { generate_uuid } from "lib/helpers";
import { GalleryField } from "components/form";
import { required, validationWrapper } from "lib/formValidations";
import { handleSuccessMessages } from "store/auth";
import { Field, Form, Formik } from "formik";
import { Loading, TextField, MultiSelect, Select,CheckBox } from "components/form";
import Modal from "components/Modal";
const MobileApp = (props) => {
  const {
    dispatch,
    getSetting,
    submitSetting,
    mobile_app,
    loading,
  } = useSetting();
  const key = "mobile_app";
  useEffect(() => {
     dispatch(getSetting(key));
   
  }, []);
  useEffect(() => {
     if(mobile_app)
     {
      setPopups(mobile_app.popups);
     }
  
   
  }, [mobile_app]);
  const [showAddPopup, setShowAddPopup] = useState(false);
  const [showEditPopup, setShowEditPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [item, setItem] = useState(false);
  const [popups, setPopups] = useState([]);

  if (loading) {
    return (
      <div className="box p-5 flex justify-center">
        <Loading />
      </div>
    );
  }

  return (
    <>
    <AddPopup
        show={showAddPopup}
        close={() => setShowAddPopup(false)}
        title="افزودن پاپ آپ"
        submit={(values)=>{setPopups([...popups,values])}}
      />
      <EditPopup
        item={item}
        show={showEditPopup}
        close={() => setShowEditPopup(false)}
        title="ویرایش پاپ آپ"
        submit={(values)=>{setPopups([...popups.filter(i=>i.uuid!==item.uuid),values])}}
      />
      <DeletePopup
        item={item}
        show={showDeletePopup}
        close={() => setShowDeletePopup(false)}
        title="حذف پاپ آپ"
        submite={async () => {
         setPopups([...popups.filter(i=>i.uuid!==item.uuid)])
        }}
      />
      <Formik
        initialValues={mobile_app || {}}
        onSubmit={async (values, { setSubmitting }) => {
          await dispatch(
            submitSetting({ value: {...values,popups}, key }, () =>
              handleSuccessMessages("ویرایش اطلاعات انجام شد")
            )
          );
          setSubmitting(false);
        }}
        enableReinitialize
      >
        {({ isSubmitting, dirty }) => (
          <Form>
            <div className="box rounded p-3">
              <h3>تنظیمات اپلیکیشن موبایل</h3>
              <hr className="my-2" />
              <div className="">
                <div className="intro-x grid grid-cols-2 gap-4">
                  <Field
                    label="نسخه اپلیکیشن موبایل(android):"
                    name="android_last_version"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />
                  <Field
                    label="لینک اپلیکیشن موبایل(android):"
                    name="android_link_version"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />
                  <Field
                    label="نسخه اپلیکیشن موبایل(ios):"
                    name="ios_last_version"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />
                  <Field
                    label="لینک اپلیکیشن موبایل(ios):"
                    name="ios_link_version"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />
                   <Field
                    label="نسخه اپلیکیشن (tv):"
                    name="tv_last_version"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />
                  <Field
                    label="لینک اپلیکیشن (tv):"
                    name="tv_link_version"
                    component={TextField}
                    validate={(value) => validationWrapper(value, required)}
                  />
                  </div>
                  <div className="box intro-y col-span-12 overflow-auto lg:overflow-visible">
                    <div className="flex justify-between py-2 px-3">
                      <h3>لیست پاپ آپ ها</h3>
                      <button type="button"
                        onClick={() => setShowAddPopup(true)}
                        className="btn btn-sm btn-primary"
                      >
                        افزودن پاپ آپ
                      </button>
                    </div>
                    <hr />
                    {popups && popups.length < 1 && (
                      <h3 className="p-5 text-center">
                        چیزی برای نمایش وجود ندارد!
                      </h3>
                    )}
                    {popups && popups.length > 0 && (
                      <table className="table table-report -mt-2">
                        <thead>
                          <tr>
                            <th className="whitespace-nowrap text-center">
عنوان
                            </th>
                           
                           
                            <th className="whitespace-nowrap text-center">
                    تصویر
                            </th>
                              <th className="whitespace-nowrap text-center">
                              تصویرافقی
                            </th>
                            <th className="whitespace-nowrap text-center">
                              وضعیت
                            </th>
                            <th className="whitespace-nowrap text-center">
                              عملیات
                            </th>
                          </tr>
                        </thead>
                        <tbody className="text-center">
                          {popups &&
                            popups.map((item) => (
                              <tr>
                                <td>{item.title}</td>
                                <td>{item.desc}</td>
                              
                                <td className="text-xs">
                                 <img style={{height: "110px"}} src={item.image_url}/>
                                </td>
                                <td className="text-xs">
                                 <img style={{height: "110px"}} src={item.horizontal_image_url}/>
                                </td>
                                <td>{item.status ? "فعال" : "غیرفعال"}</td>
                                <td className="w-56">
                                  <button
                                  type="button"
                                    className="btn btn-sm btn-info mx-1"
                                    onClick={() => {
                                      setItem(item);
                                      setShowEditPopup(true);
                                    }}
                                  >
                                    ویرایش
                                  </button>
                                  <button
                                  type="button"
                                    className="btn btn-sm btn-danger mx-1"
                                    onClick={() => {
                                      setItem(item);
                                      setShowDeletePopup(true);
                                    }}
                                  >
                                    حذف
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    )}
                  </div>

                  <button
                    className="mt-4 btn btn-primary w-20"
                    type="submit"
                    disabled={!!(isSubmitting)}
                  >
                    {isSubmitting ? <Loading /> : "ذخیره"}
                  </button>
                
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default MobileApp;




export function AddPopup(props) {
  
   return (
     <Modal show={props.show} handleClose={props.close} title={props.title}>
       <Formik
         initialValues={{ uuid: generate_uuid() }}
         onSubmit={async (values, { setSubmitting }) => {
            props.submit(values)
           setSubmitting(false);
           props.close()
         }}
         enableReinitialize
       >
         {({ isSubmitting, dirty, values }) => (
           <Form>
             <div className="box rounded p-3">
               <div className="">
                 <div className="intro-x grid grid-cols-2 gap-4">
                  
                   <Field
                     placeholder="عنوان"
                     label="عنوان :"
                     name="title"
                     component={TextField}
                   />
                   <Field
                     placeholder="عنوان انگلیسی"
                     label="عنوان انگلیسی :"
                     name="en_title"
                     component={TextField}
                   />
                  
                    <Field
                     placeholder="فعال"
                     label="فعال "
                     name="status"
                     component={CheckBox}
                     
                   />
                      <Field
                              label="تصویر:"
                              name="image_url"
                              component={GalleryField}
                              dataType="url"
                              validate={(value) => validationWrapper(value, required)}
                     />
                      <Field
                              label="تصویرافقی:"
                              name="horizontal_image_url"
                              component={GalleryField}
                              dataType="url"
                              validate={(value) => validationWrapper(value, required)}
                     />
                 
                   <br/>
                   <button
                     className="mt-4 btn btn-primary w-20"
                     type="submit"
                     disabled={!!(isSubmitting)}
                   >
                     {isSubmitting ? <Loading /> : "ذخیره"}
                   </button>
                 </div>
               </div>
             </div>
           </Form>
         )}
       </Formik>
     </Modal>
   );
 }
 
 export function EditPopup(props) {
   
   return (
     <Modal show={props.show} handleClose={props.close} title={props.title}>
       <Formik
         initialValues={props.item}
         onSubmit={async (values, { setSubmitting }) => {
          props.submit(values)
           setSubmitting(false);
           props.close()
         }}
         enableReinitialize
       >
         {({ isSubmitting, dirty, values }) => (
           <Form>
             <div className="box rounded p-3">
              
               <div className="">
                 <div className="intro-x grid grid-cols-2 gap-4">
                 <Field
                     placeholder="عنوان"
                     label="عنوان :"
                     name="title"
                     component={TextField}
                   />
                   <Field
                     placeholder="عنوان انگلیسی"
                     label="عنوان انگلیسی :"
                     name="en_title"
                     component={TextField}
                   />
                  
                    <Field
                     placeholder="فعال"
                     label="فعال "
                     name="status"
                     component={CheckBox}
                     
                   />
                      <Field
                              label="تصویر:"
                              name="image_url"
                              component={GalleryField}
                              dataType="url"
                              validate={(value) => validationWrapper(value, required)}
                     />
                          <Field
                              label="تصویرافقی:"
                              name="horizontal_image_url"
                              component={GalleryField}
                              dataType="url"
                              validate={(value) => validationWrapper(value, required)}
                     />
      <br/>
                   <button
                     className="mt-4 btn btn-primary w-20"
                     type="submit"
                     disabled={!!(isSubmitting || !dirty)}
                   >
                     {isSubmitting ? <Loading /> : "ذخیره"}
                   </button>
                 </div>
               </div>
             </div>
           </Form>
         )}
       </Formik>
     </Modal>
   );
 }
 
 export function DeletePopup(props) {
   
   return (
     <Modal show={props.show} handleClose={props.close} title={props.title}>
       <div className="modal-body gap-y-3">
         <h4>آیا از حذف این ویجت مطمئن هستید؟</h4>
       </div>
       <div className="modal-footer flex justify-between">
         <button
           className="btn btn-danger w-20"
           type="button"
           onClick={()=>{props.submite();props.close()}}
         >
           حذف
         </button>
         <button
           type="button"
           onClick={props.close}
           className="btn btn-outline-secondary w-20 mr-1"
         >
           انصراف
         </button>
       </div>
     </Modal>
   );
 }
